<template>
  <div class="main" style="background-color: silver;" >
    <div  ref="green" class="box green">a</div>
    <div class="box purple">b</div>
    <div class="box blue">c</div>

    <!-- <div class="img-box" >
        <img class="img1"  src="~@/assets/images/zy/hl/sbl0001.png">
        <img class="img2" src="~@/assets/images/zy/hl/sbl0002.png"  style="opacity: 0;" >
        <img class="img3" src="~@/assets/images/zy/hl/sbl0003.png" style="opacity: 0;" >
        <img class="img4" src="~@/assets/images/zy/hl/sbl0004.png" style="opacity: 0;" >
        <img class="img5" src="~@/assets/images/zy/hl/sbl0005.png" style="opacity: 0;" >
        <img class="img6" src="~@/assets/images/zy/hl/sbl0006.png" style="opacity: 0;" >
        <img class="img7" src="~@/assets/images/zy/hl/sbl0007.png" style="opacity: 0;" >
        <img class="img8" src="~@/assets/images/zy/hl/sbl0008.png" style="opacity: 0;" >
        <img class="img9" src="~@/assets/images/zy/hl/sbl0009.png" style="opacity: 0;" >
        <img class="img10" src="~@/assets/images/zy/hl/sbl0010.png" style="opacity: 0;" >
        <img class="img11" src="~@/assets/images/zy/hl/sbl0011.png" style="opacity: 0;" >
        <img class="img12" src="~@/assets/images/zy/hl/sbl0012.png"style="opacity: 0;"  >
        <img class="img13" src="~@/assets/images/zy/hl/sbl0013.png" style="opacity: 0;" >
        <img class="img14" src="~@/assets/images/zy/hl/sbl0014.png"style="opacity: 0;"  >
        <img class="img15" src="~@/assets/images/zy/hl/sbl0015.png" style="opacity: 0;" >
        <img class="img16" src="~@/assets/images/zy/hl/sbl0016.png" style="opacity: 0;" >
    </div> -->

    <vue-seamless-scroll :data="listData" class="warp">
    <ul class="item">
      <li v-for="(item, index) in listData" :key="index">
        <span class="title" v-text="item.title"></span>
        <span class="date" v-text="item.date"></span>
      </li>
    </ul>
  </vue-seamless-scroll>
  <!-- <div class="huogong">
    <span v-for="(item,index) in imgList">
      {{ item}}
    </span>

  </div> -->

    <canvas id="canvas" ref="huogong2" height="140" width="100"></canvas>
  </div>
</template>

<script>
import { gsap } from "gsap";
import vueSeamlessScroll from 'vue-seamless-scroll'


export default {
  components: {
      vueSeamlessScroll
    },
  data() {
    return {
      listData: [{
          'title': '无缝滚动第一行无缝滚动第一行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第二行无缝滚动第二行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第三行无缝滚动第三行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第四行无缝滚动第四行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第五行无缝滚动第五行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第六行无缝滚动第六行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第七行无缝滚动第七行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第八行无缝滚动第八行',
          'date': '2017-12-16'
        }, {
          'title': '无缝滚动第九行无缝滚动第九行',
          'date': '2017-12-16'
        }],
        aniImg: [
        require("@/assets/images/zy/hl/sbl0001.png"),
        require("@/assets/images/zy/hl/sbl0002.png"),
        require("@/assets/images/zy/hl/sbl0003.png"),
        require("@/assets/images/zy/hl/sbl0004.png"),
        require("@/assets/images/zy/hl/sbl0005.png"),
        require("@/assets/images/zy/hl/sbl0006.png"),
        require("@/assets/images/zy/hl/sbl0007.png"),
        require("@/assets/images/zy/hl/sbl0008.png"),
        require("@/assets/images/zy/hl/sbl0009.png"),
        require("@/assets/images/zy/hl/sbl0010.png"),
        require("@/assets/images/zy/hl/sbl0011.png"),
        require("@/assets/images/zy/hl/sbl0012.png"),
        require("@/assets/images/zy/hl/sbl0013.png"),
        require("@/assets/images/zy/hl/sbl0014.png"),
        require("@/assets/images/zy/hl/sbl0015.png"),
        require("@/assets/images/zy/hl/sbl0016.png"),
      ],
      imgList:[]
    };
  },
  mounted(){
    // gsap.to(".green",2.8,{stopColor: "#BF3A0B", repeat: -1,yoyo: true,ease: "rough({strength: 3, points: 10, template: Power0.easeNone, taper: none, randomize: true,clamp:false})"},0.1);
    // gsap.from(".purple", {rotation: -360, x: -100, duration: 1});
    // gsap.fromTo(".blue", {x: -100},{rotation: 360, x: 100, duration: 1});
//     gsap.fromTo([".img1",".img2",".img3",".img4",".img5"],3,{x: 100},{ x: 0,
//     duration: 5,
//     repeat: -1,
// });

    // let tl = gsap.timeline({
    //     repeat: -1
    // });
    
    
    //create the timeline
    // tl.fromTo(".img1", {opacity:1}, {opacity: 0,duration: 1}) //start sequencing
    // .fromTo(".img2", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img3", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img4", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img5", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img6", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img7", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img8", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img9", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img10", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img11", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img12", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img13", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img14", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img15", {opacity:1}, {opacity: 0,duration: 0.1})
    // .fromTo(".img16", {opacity:1}, {opacity: 1,duration: 0.5})

    this.ani();

    // gsap.to(".huogong", {
    //   keyframes: {
    //     "0%":   {},
    //     "75%":  { x: 0, y: 0,}, // finetune with individual eases
    //     "100%": { x: 50, y: 50 },
    //     easeEach: 'expo.inOut' // ease between keyframes
    //   },
    //   ease: 'none' // ease the entire keyframe block
    //   duration: 2,
    //   })

    this.aniImg.forEach((item) => {
      this.loadImage(item, (res) => {
          //console.log(res,"zzzzzzzzzzz")
          this.imgList.push(res);
          console.log(this.imgList);
      })
    })

  },
  methods:{
    ani(){
      const canvas =this.$refs.huogong2;
      const ctx = canvas.getContext('2d')
      // 存储图片的是src：
      const imgSrcs = [
        'https://img.xiaozhuan.shop/hl/sbl0001.png',
      'https://img.xiaozhuan.shop/hl/sbl0002.png',
      'https://img.xiaozhuan.shop/hl/sbl0003.png',
      'https://img.xiaozhuan.shop/hl/sbl0004.png',
      'https://img.xiaozhuan.shop/hl/sbl0005.png',
      'https://img.xiaozhuan.shop/hl/sbl0006.png',
      'https://img.xiaozhuan.shop/hl/sbl0007.png',
      'https://img.xiaozhuan.shop/hl/sbl0008.png',
      'https://img.xiaozhuan.shop/hl/sbl0009.png',
      'https://img.xiaozhuan.shop/hl/sbl0010.png',
      'https://img.xiaozhuan.shop/hl/sbl0011.png',
      'https://img.xiaozhuan.shop/hl/sbl0012.png',
      'https://img.xiaozhuan.shop/hl/sbl0013.png',
      'https://img.xiaozhuan.shop/hl/sbl0014.png',
      'https://img.xiaozhuan.shop/hl/sbl0015.png',
      'https://img.xiaozhuan.shop/hl/sbl0016.png',
    
    ]
      const img = new Image();
      var i = 0;
 

      this.mySetInterval(() => { 
        img.src = imgSrcs[i]
        img.onload = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0,80,120)
        }
        i++
        if (i === 16) {
            i = 0
            //ctx.clearRect(0, 0, canvas.width, canvas.height)
        }
    }, 200)

    },
    mySetInterval(func, detay){
      var i = 0
      var myReq = requestAnimationFrame(function fn() {
          // 判断现在处于60帧的第几帧，如果是目标帧的话，调用func函数：
          if (i % parseInt(60 / (1000 / detay)) == 0) {
              console.log(i,"mySetInterval");
              func();
          }
          i++
          // 让i值每秒增加60，循环调用func函数：
          requestAnimationFrame(fn)
      })
    },
    loadImage(url, callback) {
      var image = new Image();
      (image.onload = function() {
        (image.onload = null), callback(image);
      }),
        (image.src = url);
    },

  },
  created() {

    
  },
};
</script>

<style lang="less" scoped>

.warp {
    position: absolute;
    height: 270px;
    width: 360px;
    margin: 0 auto;
    overflow: hidden;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      li{
        display: block;
        height: 30px;
        line-height: 30px;
        display: flex;
        justify-content: space-between;
        font-size: 15px;
      }
    }
  }

.main {
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-height: 100vh;
  flex-direction: column;
}
.box{

    width: 100px;
    height: 100px;

}

.green{
background-color:green;
}
.purple{
    background-color: purple;
}
.blue{
    background-color: blue;
}


@keyframes gif {
	0% {
		background-image: url("~@/assets/images/zy/hl/sbl0001.png");
	}
	7% {
		background-image: url("~@/assets/images/zy/hl/sbl0002.png");
	}
	14% {
		background-image: url("~@/assets/images/zy/hl/sbl0003.png");
	}
	21% {
		background-image: url("~@/assets/images/zy/hl/sbl0004.png");
	}
	28% {
		background-image: url("~@/assets/images/zy/hl/sbl0005.png");
	}
    35% {
		background-image: url("~@/assets/images/zy/hl/sbl0006.png");
	}
    42% {
		background-image: url("~@/assets/images/zy/hl/sbl0007.png");
	}
    49% {
		background-image: url("~@/assets/images/zy/hl/sbl0008.png");
	}
    56% {
		background-image: url("~@/assets/images/zy/hl/sbl0009.png");
	}
    63% {
		background-image: url("~@/assets/images/zy/hl/sbl0010.png");
	}
    70% {
		background-image: url("~@/assets/images/zy/hl/sbl0011.png");
	}
    77% {
		background-image: url("~@/assets/images/zy/hl/sbl0012.png");
	}
    85% {
		background-image: url("~@/assets/images/zy/hl/sbl0013.png");
	}
    92% {
		background-image: url("~@/assets/images/zy/hl/sbl0014.png");
	}
    98% {
		background-image: url("~@/assets/images/zy/hl/sbl0015.png");
	}
    100% {
		background-image: url("~@/assets/images/zy/hl/sbl0016.png");
	}
}

.img-box {
    position: absolute;
	width: 100px;
	height: 100px;
	background-repeat: no-repeat;
	background-size: 100% 100%;
    // background-image: url("~@/assets/images/zy/hl/sbl0001.png");
	//  animation: gif 4s ease-in-out infinite;
    img{
        position: absolute;
        top:250px;
    }
}


</style>
